export default __webpack_public_path__ + "media/images/theme/bg_light-8585fbb60a3ed1878f35d6bee410f6f6.png";